import { faCog, faLineColumns, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Typography } from "antd";
import React, { useState } from "react";
export var IconSpace = function () {
    return React.createElement("span", { style: { padding: "0px 8px" } });
};
export var WidgetHeader = function (_a) {
    var title = _a.title, draggableIcon = _a.draggableIcon, viewWidgetSettings = _a.viewWidgetSettings, onCloseClick = _a.onCloseClick, onNavigationClick = _a.onNavigationClick, icons = _a.icons, subTitle = _a.subTitle;
    var _b = useState(false), popupVisible = _b[0], togglePopupVisible = _b[1];
    var onDeleteClick = function () {
        onCloseClick && onCloseClick();
        togglePopupVisible(false);
    };
    // const popup = <Popover
    //   content={<></>}
    //   overlayStyle={{ display: 'none' }}
    //   getPopupContainer={(n: HTMLElement) => { console.log(n); return document.body; }}
    //   title={null}
    //   trigger="click"
    //   visible={popupVisible}
    //   onVisibleChange={togglePopupVisible}
    //   placement="leftTop">
    // </Popover>
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: popupVisible ? {} : { display: 'none' }, className: "widget-header-main-overlay" },
            React.createElement("div", { className: "widget-header-overlay-container" },
                React.createElement(FontAwesomeIcon, { icon: faTimes, className: "widget-card-icon", 
                    // size="lg"
                    style: { float: "right", position: 'absolute', top: '16px', right: '16px' }, onClick: function () { return togglePopupVisible(false); } }),
                React.createElement(Row, null,
                    React.createElement(Typography.Title, { style: { fontSize: "24px" }, className: "color-blue-5" }, "Are you sure you want to delete this tile?")),
                React.createElement(Row, null,
                    React.createElement("div", { style: { float: "right", marginTop: '1.5rem' } },
                        React.createElement(Button, { className: "color-pink border-pink", onClick: onDeleteClick }, "Delete"),
                        React.createElement("span", { className: "padding-sm" }),
                        React.createElement(Button, { type: "primary", onClick: function () { return togglePopupVisible(false); } }, "Cancel"))))),
        React.createElement(React.Fragment, null,
            " ",
            React.createElement("div", { style: { padding: 0, display: 'flex', flexDirection: "row", marginBottom: '4px' } },
                React.createElement(Typography.Title, { level: 4, style: { margin: 0, flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', overflow: 'hidden' } },
                    React.createElement("div", { className: "wdgt-title" }, title),
                    onNavigationClick && React.createElement(React.Fragment, null,
                        React.createElement(IconSpace, null),
                        React.createElement(FontAwesomeIcon, { icon: faLineColumns, className: "widget-card-icon", size: "lg", style: { fontSize: "18px", }, onClick: function () { return onNavigationClick && onNavigationClick(); } }))),
                React.createElement(Typography.Title, { level: 4, style: { margin: 0, alignItems: 'center', justifyContent: 'flex-end', display: 'inline-flex' } },
                    React.createElement(IconSpace, null),
                    draggableIcon,
                    viewWidgetSettings && React.createElement(React.Fragment, null,
                        React.createElement(FontAwesomeIcon, { icon: faCog, className: "widget-card-icon", size: "lg", onClick: viewWidgetSettings ? function () { return viewWidgetSettings(true); } : function () { } }),
                        React.createElement(IconSpace, null)),
                    icons,
                    React.createElement(FontAwesomeIcon, { icon: faTimes, className: "widget-card-icon", size: "lg", onClick: function () { return togglePopupVisible(true); } }))),
            React.createElement("div", { style: { padding: 0, display: 'flex', flexDirection: "row" } },
                React.createElement("div", { className: "color-gray-5", style: { fontStyle: 'normal', fontWeight: 'normal', fontSize: '12px', marginBottom: '1rem' } }, subTitle))));
};
//# sourceMappingURL=widget-header.js.map